"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const navigation_1 = __importDefault(require("@App/navigation"));
const get_dsp_link_1 = require("@App/helpers/get-dsp-link");
const get_dsp_name_1 = require("@App/helpers/get-dsp-name");
const MatchDetailsRow = (props) => {
    var _a;
    const { recording } = props;
    const link = (0, get_dsp_link_1.getDSPLink)(recording.dspMNumber, recording.dspReleaseId, recording.senderResourceId);
    const recordingId = `${recording.dspMNumber}-${recording.senderResourceId}`;
    return (react_1.default.createElement("tr", null,
        react_1.default.createElement("td", null, (_a = (0, get_dsp_name_1.getFormattedDspName)(recording.dsp)) === null || _a === void 0 ? void 0 : _a.toUpperCase()),
        react_1.default.createElement("td", null, recording.recordingTitle),
        react_1.default.createElement("td", null, recording.recordingDisplayArtistName),
        react_1.default.createElement("td", null, recording.label),
        react_1.default.createElement("td", null, link ? (react_1.default.createElement("a", { target: "_blank", className: "blue-link", href: link, rel: "noreferrer" }, "Listen")) : (react_1.default.createElement("p", { className: "not-available" }, "Listen"))),
        react_1.default.createElement("td", null,
            react_1.default.createElement("a", { target: "_blank", href: navigation_1.default.recordingDetails.root(recordingId), rel: "noreferrer" }, "View"))));
};
exports.default = MatchDetailsRow;
